import { render, staticRenderFns } from "./el-form-item-countries.vue?vue&type=template&id=3c5d0f0c&"
import script from "./el-form-item-countries.vue?vue&type=script&lang=js&"
export * from "./el-form-item-countries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports